import React from 'react';
import { BookOpen, Download, Shield, ArrowRight } from 'lucide-react';
export function Offer() {
  return <section id="precio" className="py-20 md:py-28 bg-[#3D2B1F] text-[#FFF8F0] relative overflow-hidden" data-id="element-44">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-45">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#E8856C] rounded-full blur-3xl" data-id="element-46"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[#F5E6D3] rounded-full blur-3xl" data-id="element-47"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-4" data-id="element-50">
            De Modo Supervivencia a Modo Calma
          </h2>
          <p className="text-xl opacity-80" data-id="element-51">
            El sistema completo para recuperar tu paz mental
          </p>
        </div>

        {/* Offer Card */}
        <div className="bg-[#FFF8F0] text-[#3D2B1F] rounded-3xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-52">
          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-53">
            {/* Image */}
            <div className="w-full md:w-1/3" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/6CZV6Bhro6n5LAedoK4K7m/IMAGENPRODUCTO2.png" alt="Ebook Cover" className="w-full rounded-lg shadow-lg transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-55" />
            </div>

            {/* Content */}
            <div className="w-full md:w-2/3" data-id="element-56">
              <h3 className="font-bold text-xl mb-4 uppercase tracking-wide text-[#E8856C]" data-id="element-57">
                Lo que incluye:
              </h3>
              <ul className="space-y-3 mb-8" data-id="element-58">
                <li className="flex items-center gap-3" data-id="element-59">
                  <BookOpen className="w-5 h-5 text-[#E8856C]" data-id="element-60" />
                  <span data-id="element-61">Ebook completo en PDF</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-62">
                  <Download className="w-5 h-5 text-[#E8856C]" data-id="element-63" />
                  <span data-id="element-64">Plantillas imprimibles (No-Negociables, Resets)</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-65">
                  <Shield className="w-5 h-5 text-[#E8856C]" data-id="element-66" />
                  <span data-id="element-67">Protocolo de Semana de Emergencia</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-68">
                  <Shield className="w-5 h-5 text-[#E8856C]" data-id="element-69" />
                  <span data-id="element-70">Tabla Rojo/Amarillo/Verde de energía</span>
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row items-center gap-6 pt-6 border-t border-[#3D2B1F]/10" data-id="element-71">
                <div className="text-center sm:text-left" data-id="element-72">
                  <span className="block text-sm text-[#3D2B1F]/60 line-through" data-id="element-73">
                    $49 USD
                  </span>
                  <span className="block text-4xl font-bold text-[#3D2B1F]" data-id="element-74">
                    $19 USD
                  </span>
                  <span className="text-xs text-[#3D2B1F]/60" data-id="element-75">
                    Pago único. Acceso de por vida.
                  </span>
                </div>

                <a href="https://circuloactivo.com/cart/50154326720745:1" target="_blank" rel="noopener noreferrer" onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'Modo Calma Ebook',
                    content_type: 'product',
                    value: 19,
                    currency: 'USD'
                  });
                }
              }} className="w-full sm:w-auto bg-[#E8856C] hover:bg-[#D6745B] text-[#FFF8F0] px-8 py-4 rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-76">
                  Descargar Ahora
                  <ArrowRight className="w-5 h-5" data-id="element-77" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Final Soft CTA */}
        <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-78">
          <p className="font-serif text-2xl italic mb-6" data-id="element-79">
            "No necesitas convertirte en otra mujer. Necesitas un sistema que te
            sostenga cuando tú ya no puedes."
          </p>
          <p className="opacity-70 text-sm" data-id="element-80">
            Garantía de satisfacción de 30 días. Si no te sirve, te devolvemos
            tu dinero.
          </p>
        </div>
      </div>
    </section>;
}